import { Component, NgModule, ViewChild, AfterViewInit, OnInit  } from '@angular/core';
import { City, Contract, ContractService, Country, CustomerSite, Material, StateProvince, SupplyMode } from "../../../contracts/services/contract.service"
import { NotificationService } from "../../../common/component/notification/notification.service"
import { ActivatedRoute, Router } from '@angular/router';
import { DxListComponent, DxListModule, DxPopupModule } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'app-modifycontract',
  templateUrl: './modifycontract.component.html',
  styleUrls: ['./modifycontract.component.scss']
})
export class ModifyContractComponent implements OnInit {
  @ViewChild(DxListComponent, { static: false }) dataList: DxListComponent;
  id: number = 0;
  materials: Material[];
  awardYears: string[];
  supplyModes: string[];
  suppliers: any;
  quantityUoms: string[];
  countries: Country[];
  states: StateProvince[];
  cities: City[];
  filteredCountries: string[];
  filteredStates: string[];
  filteredCities: string[];
  citiesDataSource: DataSource;
  priceUoms: string[];
  supplyModeList: any;
  originalContractsList: Contract[];
  country: string;
  public contractItem: Contract;
  public frmCustomerSite: CustomerSite;
  customerSiteList: CustomerSite[];
  filteredCustomerSiteList: CustomerSite[];
  customerName: string;
  materialName: string;
  supplierName: string;
  supplyModeName: string;
  awardYearFrom: string;
  awardYearTo: string;
  commenceYearFrom: string;
  commenceYearTo: string;
  isLoadPanelVisible: boolean = false;
  contractResponseReceived: boolean;
  supplierResponseReceived: boolean;
  qtyUomsResponseReceived: boolean;
  priceUomsResponseReceived: boolean;
  materialResponseReceived: boolean;
  siteInfoResponseReceived: boolean;
  countryResponseReceived: boolean;
  stateResponseReceived: boolean;
  cityResponseReceived: boolean;
  title: string;
  popupVisible: boolean;
  siteName: string;
  state: string;
  city: string;

  saleAmountHeaderFilter: any;
  applyFilterTypes: any;
  currentFilter: any;
  showFilterRow: boolean;
  showHeaderFilter: boolean;
  createMode: boolean;
  employee: any;
  selectionModeValue = 'single';
  numberPattern: any = /^(0|[1-9][0-9]*)$/;
  decimalOnePlace: any = /^\d*(\.\d{1,1})?$/;
  decimalTwoPlaces: any = /^\d*(\.\d{1,2})?$/;


  constructor(public contractService: ContractService,
    private route: ActivatedRoute,
    private router: Router,
    public notificationService: NotificationService) {
    this.supplyModes = contractService.getSupplyModes();
    this.customerName = '';
    this.materialName = '';
    this.supplierName = '';
    this.supplyModeName = '';
    this.awardYearFrom = '';
    this.awardYearTo = '';
    this.commenceYearFrom = '';
    this.commenceYearTo = '';
    this.showFilterRow = true;
    this.showHeaderFilter = true;
    this.contractResponseReceived = false;
    this.supplierResponseReceived = false;
    this.createMode = false;
    this.title = 'Choose Site'
    this.popupVisible = false;
    this.countries = [];
    this.filteredStates = [];
    this.cities = [];
    this.frmCustomerSite = new CustomerSite();
    this.awardYears = contractService.getAwardYears();
  }

  ngOnInit(): void {
    this.isLoadPanelVisible = true;
    //**************Get User ID On Edit********************* */
    this.getSuppliers();
    this.getMaterials();
    this.getQuantityUoms();
    this.getPriceUoms();
    
    this.route.params.subscribe(params => {
      this.id = params['id'];
      if (params['id'] != null) {
         this.contractItem = this.getContractDetails(this.id);
         this.createMode = false;
      }
      else
      {
        this.createMode = true;
        this.contractItem = new Contract();
        this.isLoadPanelVisible = false;
      } 
    });
  }

  handleSubmit (e) {
    this.isLoadPanelVisible = true;
    e.preventDefault();
    this.contractService.saveContractDetails(this.contractItem).subscribe(data => {
      if (data) {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("success", "Record saved successfully", null );
        this.router.navigate(['/contracts']);
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the contract information", error);
          this.isLoadPanelVisible = false;
        });
}

  getSuppliers() {
    try {
      this.contractService.getSuppliers().subscribe(data => {
      if (data) {
        this.suppliers = data;
        this.supplierResponseReceived = true;
        if(this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the suppliers", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the suppliers", null);
      this.isLoadPanelVisible = false;
    }
  }

  getMaterials() {
    try {
      this.contractService.getMaterials().subscribe(data => {
      if (data) {
        this.materials = data;
        this.materialResponseReceived = true;
        if(this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the materials", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the materials", null);
      this.isLoadPanelVisible = false;
    }
  }

  getCountries() {
    try {
      this.contractService.getCountries().subscribe(data => {
      if (data) {
        this.countryResponseReceived = true;
        this.countries = data;
        this.filteredCountries = [...new Set(this.countries.map(item => item.countryName))];
        this.filteredCountries.sort();
        if(this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the states", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the states", null);
      this.isLoadPanelVisible = false;
    }
  }

  getStates() {
    try {
      this.contractService.getProvinces().subscribe(data => {
      if (data) {
        this.stateResponseReceived = true;
        this.states = data;
        if(this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the states", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the states", null);
      this.isLoadPanelVisible = false;
    }
  }

  getCities() {
    try {
      this.contractService.getCities().subscribe(data => {
      if (data) {
        this.cityResponseReceived = true;
        this.cities = data;
        if(this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the materials", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the materials", null);
      this.isLoadPanelVisible = false;
    }
  }

  hasAllResponseReceived(): boolean {
    if(this.createMode)
      return this.supplierResponseReceived && this.materialResponseReceived && this.qtyUomsResponseReceived 
              && this.priceUomsResponseReceived;
    else
    return this.supplierResponseReceived && this.materialResponseReceived && this.qtyUomsResponseReceived 
    && this.priceUomsResponseReceived && this.contractResponseReceived;
  }

  hasPopupServiceResponseReceived(): boolean {
    return this.siteInfoResponseReceived && this.countryResponseReceived && this.stateResponseReceived && this.cityResponseReceived;
  }

  getQuantityUoms() {
    try {
      this.contractService.getQuantityUoms().subscribe(data => {
      if (data) {
        this.quantityUoms = data;
        this.quantityUoms.unshift('');
        this.qtyUomsResponseReceived = true;
        if(this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the Quantity Uoms", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the Quantity Uoms", null);
      this.isLoadPanelVisible = false;
    }
  }

  getPriceUoms() {
    try {
      this.contractService.getPriceUoms().subscribe(data => {
      if (data) {
        this.priceUoms = data;
        this.priceUoms.unshift('');
        this.priceUomsResponseReceived = true;
        if(this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the Price Uoms", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the Price Uoms", null);
      this.isLoadPanelVisible = false;
    }
  }

  getSites() {
    try {
      this.contractService.getCustomerSites().subscribe(data => {
      if (data) {
        this.customerSiteList = data;
        this.siteInfoResponseReceived = true;
        if(this.hasPopupServiceResponseReceived()) this.isLoadPanelVisible = false;
        }
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the Price Uoms", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the Price Uoms", null);
      this.isLoadPanelVisible = false;
    }
  }

  getContractDetails(id: number): Contract {
    try {
      this.contractService.fetchContractDetails(id).subscribe(data => {
      if (data) {
        this.contractItem = data;
        this.contractResponseReceived = true;
        if(this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
          return data;
        }
        else
        return null;
      },
        error => {
          this.notificationService.alert("error", "Error occured while fetching the contract details", error);
          this.isLoadPanelVisible = false;
        });
    }
    catch (e) {
      this.notificationService.alert("error", "Error occured while fetching the contract details", null);
      this.isLoadPanelVisible = false;
    }
    return null;
  }

  resetFilters() {
    this.router.navigate(['/contracts']);
  }

  openPopup() {
    this.popupVisible = true;
  }

  selectSite() {
    if(!this.dataList.selectedItems) return;
    this.contractItem.siteId = this.dataList.selectedItems[0].siteId;
    this.contractItem.customer = this.dataList.selectedItems[0].customer;
    this.clearFields();
    this.popupVisible = false;
  }

clearFields() {
  this.siteName = null;
    this.country = null;
    this.state = null;
    this.city = null;
}

setPopupVisibility(data) {
  this.popupVisible = data;
}

setSiteId(data) {
  this.contractItem.siteId = data;
}

setCustomer(data) {
  this.contractItem.customer = data;
}

addNewCustomerSite() {
  alert('Functionality not implemented!');
}
} 